import React, { useState } from "react";
import axios from "axios";
import styles from "./UserComponent.module.css"
import { FormControlLabel, Checkbox, Grid } from "@mui/material";
import { API_URL } from '../settings';
import { useAuth } from "../Hooks/useAuth";
import { Link } from "react-router-dom";
import { CheckboxStyle } from "./MuiStyles/Styles";
import CurrentSignatureComponent from "./CurrentSignatureComponent";
import popupAlert from "./Components/popupAlert";

const UserComponent = ({user, chosenRange, handleSelectedUsers}) => {
    const storedUser = useAuth() // Retrieve user token from local storage
    const createMarkup = (user) => ({__html: user}) 
    const objConverter = data => Object.keys(data).map(key => ({ key: key, value: data[key] }) )
    const [ currentEmail, setCurrentEmail ] = useState() // State to see current active Gmail signature

    // Function to post html design
    const postUserDesign = data => {
        axios.post(`${API_URL}/users/email-signature`, data, { headers: { token: storedUser.user.data.token}})
        .then(() => popupAlert('Signature Posted!', 'success') ).catch(error => console.log(error))
    }

    return (
        <Grid key={user.data.userId} container spacing={2} style={{border:"solid 1px #6D9E93", margin:"2rem 0", borderRadius:"15px"}}>
            {/* // HTML Design */}
            <Grid item xl={4} dangerouslySetInnerHTML={ createMarkup(user.html) } style={{margin:"3rem 0"}} />
            {/* Data list */}
            <Grid item xl={4} style={{padding:"5rem", wordWrap: "break-word"}}>
                {objConverter(user.data).map(item => (
                    <h6 style={{fontWeight:"600", margin:"0.5rem 0", color:"#6D9E93"}} key={item.key}>{item.key}: <span style={{fontWeight:"100", color:"#32322F"}}>{item.value}</span></h6>
                ))}
            </Grid>
            {/* Link to Details */}
            <Grid item xl={4} md={12} className={styles.buttonsCol}>
                <Link target="_blank" to={`/user-details/${chosenRange}/${user.data.Email}`}><button className={styles.postButton}>Detail</button></Link>
                {/* See current Gmail Active Signature */}
                <button className={styles.postButton} onClick={() => setCurrentEmail(user.data.Email) }>Current</button>
                { currentEmail && <CurrentSignatureComponent email={currentEmail} setCurrentEmail={setCurrentEmail} /> }
                {/* Posting Button */}
                <button onClick={() => postUserDesign(user)} className={styles.postButton}>
                    Save
                </button>
                <div>
                    <FormControlLabel control={<Checkbox onChange={e => handleSelectedUsers(e.target.checked, user.data.Email, user.html)} sx={CheckboxStyle} />} sx={CheckboxStyle} label="Select to save" />
                </div>
            </Grid>
        </Grid>
    )
}
export default UserComponent;